(function () {
  var init = function () {
    var quickViewBtns = document.querySelectorAll('.quick-view-btn[data-product]')
    var quickViewVM = new Vue({
      el: '#quick-view',
      data: {
        show: false,
        submitted: false,
        cart: {},
        product: {},
        currentVariant: {},
        affiliate: {},
        selectedOptions: [],
        selectedQuantity: 1
      },
      watch: {
        product: function (product) {
          this.selectedOptions = this.availableVariants[0] ? this.availableVariants[0].options : []
          this.selectedQuantity = 1

          this.refreshSliders()
          this.refreshReviews()
        },
        selectedOptions: function (options) {
          const selectedVariantTitle = options.join(' / ')

          const availableVariant = this.availableVariants.find(function (variant) {
            return variant.title === selectedVariantTitle
          })

          if (availableVariant) {
            this.currentVariant = availableVariant
          } else {
            const nextAvailableVariant = this.availableVariants.find(function (variant) {
              return variant.option1 === options[0]
            })

            this.currentVariant = nextAvailableVariant
            this.selectedOptions = nextAvailableVariant.title.split(' / ')
          }
        },
      },
      computed: {
        hasOptions: function () {
          return this.product.variants &&
            this.product.variants[0].option1 !== 'Default Title'
        },
        availableVariants: function () {
          if (this.product.variants && this.product.variants.length) {
            return this.product.variants.filter(function (variant) {
              return variant.available
            })
          }

          return []
        },
        availableOptions: function () {
          if (this.availableVariants.length) {
            return this.availableVariants.reduce(function (options, variant) {
              if (!options[variant.option1]) options[variant.option1] = {}
              if (variant.option2 && !options[variant.option1][variant.option2]) options[variant.option1][variant.option2] = {}
              if (variant.option3 && !options[variant.option1][variant.option2][variant.option3]) options[variant.option1][variant.option2][variant.option3] = {}

              return options
            }, {})
          }

          return {}
        },
        availableOptionsForCurrentSelection: function () {
          if (Object.keys(this.availableOptions).length && this.currentVariant.id) {
            const availableOptions = this.availableOptions
            const currentVariant = this.currentVariant

            return this.product.options.map(function (optionsObj) {
                switch (optionsObj.position) {
                  case 1:
                    optionsObj.values = Object.keys(availableOptions)
                    break

                  case 2:
                    if (availableOptions[currentVariant.option1]) {
                      optionsObj.values = Object.keys(availableOptions[currentVariant.option1])
                    }
                    break

                  case 3:
                    if (availableOptions[currentVariant.option1][currentVariant.option2]) {
                      optionsObj.values = Object.keys(availableOptions[currentVariant.option1][currentVariant.option2])
                    }
                    break
              }

              return optionsObj
            })
          }

          return this.product.options
        },
        /**
         * Some product data is embedded as HTML in the product description. We
         * have to copy the description into a dummy element to be able to
         * properly pull these up.
         */
        productDescriptionEl: function () {
          var productDescriptionEl = document.createElement('div')
          productDescriptionEl.innerHTML = this.product.description
          return productDescriptionEl
        },
        deliveryInfo: function () {
          var deliveryInfo = this.productDescriptionEl.querySelector('#delivery-info')
          return deliveryInfo ? deliveryInfo.textContent : ''
        },
        suitableFor: function () {
          var suitableFor = this.productDescriptionEl.querySelector('#good-for')
          return suitableFor ? suitableFor.textContent : ''
        }
      },
      methods: {
        setAffiliate: function (data) {
          if (data.isOutlink) {
            // Check if is using Outlinks' Multiple Links feature
            const url = data.isoutpage
              ? 'https://outpage.co/' + this.product.id
              : data.url

            this.affiliate = { text: data.linktext, url: url }
          } else if (data['spreadr-tag']) {
            // Spreadr loads the button text directly into liquid, using the
            // currently used in prod value
            this.affiliate = { text: 'View Now', url: data['spreadr-url'] }
          } else {
            this.affiliate = data
          }
        },
        refreshSliders: function () {
          var $navSlider = $(this.$refs.galleryNavSlider)
          var $previewSlider = $(this.$refs.galleryPreviewSlider)

          this.$nextTick(function () {
            var $navSlider = $(this.$refs.galleryNavSlider)
            var $previewSlider = $(this.$refs.galleryPreviewSlider)

            if ($navSlider[0].slick || $previewSlider[0].slick) {
              $navSlider.slick('unslick')
              $previewSlider.slick('unslick')
            }

            $navSlider.slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              asNavFor: $previewSlider,
              centerMode: true,
              centerPadding: '32px',
              infinite: false,
              focusOnSelect: true,
              vertical: true,
              prevArrow: $(this.$refs.galleryNavSliderPrevArrow),
              nextArrow: $(this.$refs.galleryNavSliderNextArrow),
            })

            $previewSlider.slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              fade: true,
              infinite: false,
              asNavFor: $navSlider,
              appendDots: $(this.$refs.galleryPreviewSliderDots),
              prevArrow: $(this.$refs.galleryPreviewSliderPrevArrow),
              nextArrow: $(this.$refs.galleryPreviewSliderNextArrow)
            })
          })
        },
        refreshReviews: function () {
          this.$nextTick(function () {
            if (typeof yotpoWidgetsContainer !== 'undefined') {
              yotpoWidgetsContainer.initWidgets()
            }
          })
        },
        toggle: function () {
          this.show = !this.show

          if (!this.show) {
            this.submitted = false
          }
        },
        submit: function () {
          var postBody = { items: [{
            quantity: this.selectedQuantity,
            id: this.currentVariant.id
          }] }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(postBody)
          })
            .then(function (res) { return res.json() })
            .then(function (data) {
              if (updateCartTotals) {
                updateCartTotals(function (cart) { this.cart = cart }.bind(this))
              }

              this.submitted = true
            }.bind(this))
        }
      }
    })

    window.loadQuickView = async (evt) => {
      const productHandle = evt.target.getAttribute('data-product')

      if (!productHandle) return

      evt.preventDefault()

      const res = await fetch('/products/' + productHandle + '.js')
      const product = await res.json()

      let isAkcStoreReports = product.vendor === 'AKC Store Reports'? true : false;
      let hasRequiredFields = product.tags.includes('has-required-fields')

      let affiliate

      if (isAkcStoreReports || hasRequiredFields) {
        affiliate = { text: 'View Now', url: product.url, target: '_self' }
      } else if (evt.target.getAttribute('data-product-affiliate')) {
        affiliate = JSON.parse(evt.target.getAttribute('data-product-affiliate')) || {}
      } else {
        const productPageRes = await fetch('/products/' + productHandle)
        const productPageText = await productPageRes.text()
        const productPage = new DOMParser().parseFromString(productPageText, 'text/html')

        affiliate = JSON.parse(productPage.querySelector('.product__affiliate[type="application/json"]').textContent) || {}
      }

      quickViewVM.product = product
      quickViewVM.setAffiliate(affiliate)
      quickViewVM.toggle()
    }

    var loadSearchQuickViews = () => {
      $(`.smart-collection [product_id]`).each((i, product) => {
        const $product = $(product)
        const url = $product.find(`.isp_product_info .isp_product_image_href`).attr('href')
        const productHandle = url.substring(url.indexOf('/products/') + 10, (url.lastIndexOf('?') == -1 ? url.length : url.lastIndexOf('?')))
        const $button = $(`
          <button
            class="btn quick-view-btn"
            data-product="${productHandle}"
          >
            Quick Shop
          </button>
        `)
        $button.click(loadQuickView)
        $product.append($button)
      })
    }

    quickViewBtns.forEach(function (el) {
      el.addEventListener('click', loadQuickView)
    })

    window.quickViewCB = (data, facetsOnly) => {
      if (!facetsOnly) loadSearchQuickViews()
    }

    // close pop up when clicking outside quick view
    window.addEventListener('click', function (evt) {
      // check if the click is inside the modal
      if (!evt.target.closest(".quick-view__modal")) {
        let modalElement = document.querySelector("#quick-view")
        modalElement.style.display = "none"
      }
      evt.stopPropagation()
    })

    loadSearchQuickViews()
  }

  // Load dependencies then initialize
  var script = document.createElement('script')
  script.src = 'https://cdn.jsdelivr.net/combine/npm/mdn-polyfills@5.20.0/NodeList.prototype.forEach.min.js,npm/unfetch@4.1.0/polyfill/index.min.js,npm/vue@2.6.11,npm/slick-carousel@1.8.1'
  script.async = true
  script.addEventListener('load', init)
  document.body.appendChild(script)
})()
